import { render, staticRenderFns } from "./Translators.vue?vue&type=template&id=0b3e4db1&scoped=true"
import script from "./Translators.vue?vue&type=script&lang=js"
export * from "./Translators.vue?vue&type=script&lang=js"
import style0 from "./Translators.vue?vue&type=style&index=0&id=0b3e4db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e4db1",
  null
  
)

export default component.exports